import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const txId = sp.get("tx_id");
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!txId) { setStatus("failed"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const r = await api(`/payments/tlync/status/${txId}`);
        const st = r.status || r.state;
        if (st === "success") { setStatus("success"); refresh(); return true; }
        if (st === "failed") { setStatus("failed"); return true; }
      } catch {}
      return false;
    };
    const id = setInterval(async () => {
      tries += 1;
      const done = await poll();
      if (done || tries > 20) clearInterval(id);
    }, 2000);
    poll();
    return () => clearInterval(id);
  }, [txId]); // eslint-disable-line

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl border border-[#E8EAF2] p-10 text-center max-w-md w-full animate-fade-in-up">
        {status === "pending" && <><Loader2 size={64} className="animate-spin text-[#FF3D5A] mx-auto" /><h1 className="text-xl font-black text-[#161629] mt-4">جارٍ تأكيد الدفع...</h1><p className="text-[#6B7280] mt-1">لحظة من فضلك</p></>}
        {status === "success" && <><CheckCircle2 size={64} className="text-[#00D26A] mx-auto" /><h1 className="text-xl font-black text-[#161629] mt-4">تم الدفع بنجاح ✅</h1><button onClick={() => navigate("/orders")} className="w-full mt-6 py-3.5 rounded-2xl bg-[#FF3D5A] text-white font-black">عرض الطلبات</button></>}
        {status === "failed" && <><XCircle size={64} className="text-[#FF3D5A] mx-auto" /><h1 className="text-xl font-black text-[#161629] mt-4">تعذّر إتمام الدفع</h1><button onClick={() => navigate("/")} className="w-full mt-6 py-3.5 rounded-2xl bg-[#FF3D5A] text-white font-black">العودة للرئيسية</button></>}
      </div>
    </div>
  );
}
